import { Button } from "@mui/material";
import MarkdownEditor from "@uiw/react-markdown-editor";
import { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import { Backend } from "../services/Backend";
import { Link, useParams } from "react-router-dom";
import { SuccessToast } from "../utils/utils";

export default function AdminEditPage() {
    const { keyName } = useParams();

    const [value, setValue] = useState("");
    const [pageName, setPageName] = useState("");

    const modules = {
        toolbar: [
          [{ 'header': [1, 2, 3, 4] }],
          [{ 'size': ['small', 'medium', 'large'] }],
          ['bold', 'italic', 'underline','strike', 'blockquote'],
          [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}, {'align': [] }],
          ['link', 'image'],
          ['clean'],
        ],
    };

    useEffect(() => {
        Backend.get(`app-page/${keyName}`)
            .then(res => {
                setValue(res.content);
                setPageName(res.name);
            });
    },[]);
    
    const onChange = (val) => {
        setValue(val);
        console.log(val);
    }

    const onSave = () => {
        Backend.put(`app-page/${keyName}`, value)
            .then(res => {
                SuccessToast("Page updated!");
                setTimeout(() => window.location.href = '/dashboard/pages', 1000);
            });
    }


    return <>
        <Link to="/dashboard/pages">Back</Link>
        <h3>Edit <b>{pageName}</b> page</h3>
        <br />
        <ReactQuill theme="snow" modules={modules} value={value} onChange={onChange} className="h-[300px]" />
        {/* <MarkdownEditor
            // value={markdown}
            height="400px"
            // onChange={(value, viewUpdate) => setMarkdown(value)}
        /> */}

        <Button
            variant="contained"
            sx={{ mt: 7, mb: 2 }}
            onClick={onSave}
        >
        Save
        </Button>
    </>
}